import { ReportPayload } from "./report.payload";

export class AuditReportLog {

    reportType: string;
    reportView: string;
    action: string;
    reportName: string;
    filters: ReportPayload;
    loggedInUser:string;
}

export const ReportAction = {
    VIEW:"View",
    DOWNLOAD:"Download",
    DELETE:"Delete",
    SAVE:"Save",
    FIND:"Find"
}


// WEBPACK FOOTER //
// ./src/app/modules/reports/entities/audit-report-log.ts